export default class UserModel {
  constructor(param: any) {
    if (!param) {
      // @ts-ignore
      this.userID = "";
      // @ts-ignore
      this.userCode = "";
      // @ts-ignore
      this.userName = "";
      // @ts-ignore
      this.extra = {};
      return;
    }

    // @ts-ignore
    this.userID = param.userID;
    // @ts-ignore
    this.userCode = param.userCode;
    // @ts-ignore
    this.userName = param.userName;
    // @ts-ignore
    this.extra = param.extra;
  }
}
